import { render, staticRenderFns } from "./next-notification.vue?vue&type=template&id=3b5000ba&"
import script from "./next-notification.vue?vue&type=script&lang=js&"
export * from "./next-notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports